import axios from "axios";
import { AuthStoreInstance } from "../../features/auth/store/AuthStore";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use((config) => {
  const token = AuthStoreInstance.sessionId;
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

instance.interceptors.response.use(
  (request) => request,
  (error) => {
    const code = error.response.data.error_code;
    if (code === 1001 || code === 1002 || code === 1003 || code === 1004) {
      AuthStoreInstance.logout();
    }
    if (error.response || axios.isCancel(error)) {
      if (error.response?.status === 403) {
        AuthStoreInstance.logout();
      }
    } else {
      console.log({ error, s: error.code });
    }
    return Promise.reject(error);
  }
);

export const get = instance.get;
export const post = instance.post;
export const put = instance.put;
export const remove = instance.delete;
export const patch = instance.patch;
